/**
 * Collection facet filters — auto-submit on change + drawer a11y
 */
(function () {
  'use strict';

  class FacetFiltersForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.debounceTimer = null;
      if (!this.form) return;
      this.form.addEventListener('input', this.onInput.bind(this));
      this.form.addEventListener('change', this.onChange.bind(this));
    }

    onInput(event) {
      if (event.target.type !== 'number') return;
      clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(() => this.submitForm(), 500);
    }

    onChange(event) {
      if (event.target.type === 'number') return;
      this.submitForm();
    }

    submitForm() {
      const formData = new FormData(this.form);
      const params = new URLSearchParams();
      for (const [key, value] of formData.entries()) {
        if (value !== '') params.append(key, value);
      }
      window.location.href = `${this.form.action}?${params.toString()}`;
    }
  }

  let facetsTrigger = null;

  function getDrawer() {
    return document.querySelector('[data-facets-drawer]');
  }

  function openFacetsDrawer() {
    const drawer = getDrawer();
    if (!drawer) return;
    facetsTrigger = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('overflow-hidden');
    const closeBtn = drawer.querySelector('[data-facets-close][aria-label]');
    if (closeBtn) closeBtn.focus();
  }

  function closeFacetsDrawer() {
    const drawer = getDrawer();
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('overflow-hidden');
    if (facetsTrigger && typeof facetsTrigger.focus === 'function') facetsTrigger.focus();
  }

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-facets-open]')) {
      openFacetsDrawer();
      return;
    }
    if (e.target.closest('[data-facets-close]') || e.target.matches('[data-facets-drawer] > .absolute.inset-0')) {
      closeFacetsDrawer();
    }
  });

  document.addEventListener('keydown', (e) => {
    const drawer = getDrawer();
    if (!drawer?.classList.contains('is-open')) return;
    if (e.key === 'Escape') {
      e.preventDefault();
      closeFacetsDrawer();
      return;
    }
    if (window.OrichA11y) {
      window.OrichA11y.trapFocus(drawer.querySelector('.absolute.bottom-0') || drawer, e);
    }
  });

  if (!customElements.get('facet-filters-form')) {
    customElements.define('facet-filters-form', FacetFiltersForm);
  }
})();
